module.exports = __webpack_public_path__ + "static/img/prospectdld_used.34afed6.jpg";